/** True when a persisted workflow/component error string is present. */
export function hasPersistedErrorText(value: unknown): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}

type ErrorFields = {
  errorComponentId?: string | null;
  errorComponentMessage?: string | null;
  errorComponent?: string | null;
};

export function recordHasComponentError(record: ErrorFields): boolean {
  return [
    record.errorComponentId,
    record.errorComponentMessage,
    record.errorComponent,
  ].some(hasPersistedErrorText);
}

export type WorkflowErrorSource = ErrorFields & {
  components?: ReadonlyArray<ErrorFields> | null;
};

/** Execute Workflow stays disabled after refresh when the server still reports a component error. */
export function workflowHasComponentErrors(
  workflow: WorkflowErrorSource | null | undefined
): boolean {
  if (!workflow) return false;
  if (recordHasComponentError(workflow)) return true;
  return (workflow.components ?? []).some(recordHasComponentError);
}
